
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/discovery",
      function () {
        return require("private-next-pages/tools/discovery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/discovery"])
      });
    }
  